export default "__VITE_ASSET__DaYgG_eS__"